import { IFramework, IWebServiceManager, HttpMethod, IUserContext } from "@truckdown/framework";
import { ISearchHistoryService } from "./ISearchHistoryService";
import { ArrayResultModel } from "./Models/ArrayResultModel";
import { GetSearchRequestsModel } from "./Models/GetSearchRequestsModel";
import { SearchRequestModel } from "./Models/SearchRequestModel";

interface IResponse {
    ok: boolean,
    message: string,
    data: number
}

class SearchHistoryService implements ISearchHistoryService {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;
    private readonly basePath: string = '/locations';

    async getRequestHistoryCount(model?: GetSearchRequestsModel): Promise<number> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/get-search-history-count' + this.getQueryString(model),
            method: HttpMethod.GET
        });

        let res = await this.manager
            .get<IResponse>(req);
        return res.data;
    }

    getRequestHistory(model?: GetSearchRequestsModel): Promise<ArrayResultModel<SearchRequestModel>> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/get-search-history' + this.getQueryString(model),
            method: HttpMethod.GET
        });

        return this.manager
            .get<ArrayResultModel<SearchRequestModel>>(req);
    }

    private getQueryString(model?: GetSearchRequestsModel): string {
        if (!model) {
            return '';
        }

        var vals: string[] = [];

        if (model.startDate) {
            vals.push('startDate=' + model.startDate.toISOString());
        }
        if (model.endDate) {
            vals.push('endDate=' + model.endDate.toISOString());
        }
        if (model.limit) {
            vals.push('limit=' + model.limit);
        }
        if (model.lastTime) {
            vals.push('lastTime=' + model.lastTime.toISOString());
        }
        if (model.lastId) {
            vals.push('lastId=' + encodeURIComponent(model.lastId));
        }
        if (model.showAll) {
            vals.push('showAll=' + (model.showAll ? 'true' : 'false'));
        }

        if (vals.length == 0) {
            return '';
        }

        return '?' + vals.join('&');
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<ISearchHistoryService>('ISearchHistoryService', (frm) => {
        return new SearchHistoryService(frm);
    });
}
